<template>
	<div
		class="recipe-box shadow-box"
		:class="{
			'premium': isRecipePremium(item),
			'unavailable': !isRecipeAvailable,
			'green': isRecipeInBox,
			'ma-1' : homeSlider
		}"
		v-if="item"
	>

		<router-link
			v-if="!homeSlider"
			class="recipe-image"
			:to="{ name: this.path, params: { id: item.url ? item.url : item.id }}"
		>
			<loading-spin 
            	white 
            	v-if="isLoading" 
            	background
            /> 
			<progressive-image
				:class="{ hover: isHover }"
				:src="item.images.small ? item.images.small : item.images.big"
			/>

			<wishlist-button
				@onClick="$emit('addToWishList', item)"
				v-if="wishlist"
				:isOnWishlist="isOnWishlist"
			/>
			<div
				class="container-recipe-tags"
			>
				<tags-line-orange
					:items="tagsMarketing"
				/>
				<tag-price
					:item="item"
					:people="people"
				/>
			</div>
		</router-link>

		<div v-else class="recipe-image">
			<progressive-image
				:src="item.images.small ? item.images.small : item.images.big"
			/>
			<div
				class="container-recipe-tags"
			>
				<tags-line-orange
					:items="tagsMarketing"
				/>
				<tag-price
					:item="item"
					:people="people"
				/>
			</div>
		</div>
		
		<div class="recipe-info">
			<div
				class="recipe-name"
			>
				<div class="title" :class="{'homeslider-title' : homeSlider }" @click="!homeSlider ? toRecipe(item.id): ''">{{ item.name }}</div>
				<div class="label" v-if="isElectrolux">
					<span>
						Creata per <img class="logo" :src="require('../assets/img/campaigns/electrolux/electrolux_logo_blue.jpg')">
					</span>
				</div>
			</div>

			<div class="recipe-bottom">
				<div>
					<div
						class="inline"
						v-if="item.preparation_time"
					>
						<i class="far fa-clock" /> {{ item.preparation_time }} {{ $t("general.minutes") }}&nbsp;
					</div>
					
					<div
						class="recipe-tag-nutrition inline"
						v-for="(tag, index) in nutritionTags(item)"
						:key="index"
					>
						<img
							:src="tag.icon"
						>
							{{ tag.name }}
						<span
							v-if="index+1 !== nutritionTags(item).length"
							v-html="`, `"
						/>
					</div>
				</div>

				<section-toggle
					:trigger.sync="showInfo"
					v-show="!homeSlider"
				>
					<template slot="title">
						<b>Ingredienti</b>
					</template>

					<template slot="content">
						<div class="flex flex-wrap section-ingredients" v-if="!loading && raw">

							<SliderQ
								:maxNumSlides="6"
								:minSizeOfSlide="70"
							>
								<slide
									v-for="(ingredient, index) in raw.ingredients"
									class="ingredient"
								>
									<div class="ingredient-badge flex-center">
										<img :src="ingredient.images.small">
									</div>
									<div
									class="mt-1"
										v-html="ingredient.name"
									/>
								</slide>
							</SliderQ>

							<p v-if="showLabelDoubleIngredients(item)">
								(le quantità raddoppiano per il piano da 4)
							</p>
							<div v-if="raw.allergens.length > 0">
								<b>Allergeni:</b><br> {{ allergens }}
							</div>
						</div>
						<div v-if="loading">
							Caricamento...
						</div>
					</template>
				</section-toggle>

				<div class="recipe-action extra-action" v-if="isActionAllowed">

					<template v-if="quantity > 0">
						<div
							class="flex align-items-center"
						>
							<CTA
								class="full"
								:disabled="updating"
								@click="$emit('recipeAction', { recipe: item, quantity: quantity-1, action: 'remove' }); resetCount() "
								:content="`-`"
							/>

							<div class="quantity-extra" style='margin-top: 5px'>
								{{ people * quantity }} Porzioni Aggiunte
							</div>

							<CTA
								class="full"
								:disabled="maxReached || updating || availability - quantity <= 0"
								@click="$emit('recipeAction', { recipe: item, quantity: quantity+1 });"
								:content="`+`"
							/>
						</div>
					</template>
					<template v-else>

						<CTA
							v-if="isRecipeAvailable"
							:content="isRecipeInBox ? 'Nel box' : $mq.isDesktop() ? $t('components.checkout.cart.edit.desktop') : $t('components.checkout.cart.edit.mobile_alt')"
							:class="{ 'in-box': isRecipeInBox, 'not-in-box': !isRecipeInBox }"
							@click="$emit('recipeAction', { recipe: item, quantity: quantity+1, action: 'add' });"
							:disabled="maxReached || updating || availability - quantity <= 0"
						/>
					</template>

					<span
						class="disabled-label"
						v-if="!isRecipeAvailable"
						v-text="`Andata a Ruba!`"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InfoTooltip from './Parts/InfoTooltip'
import SectionToggle from './Parts/SectionToggle'
import TagsLineOrange from './Parts/TagsLineOrange'
import TagPrice from './Parts/TagPrice'
import WishlistButton from './SocialShare/WishlistButton'

import { configStore } from '../store/configStore' 
import { plansStore } from '../store/plansStore' 
import { RecipeApi } from '../api/RecipeApi'

export default {
	data () {
		return {
			showInfo: false,
			loading: false,
			raw: null,
			configStore: configStore.state,
			plansStore: plansStore.state,
		}
	},
	watch: {
		showInfo: function (newValue, oldValue) {
			newValue && this.loadInfo(newValue)
		}
	},
	props: {
		maxReached: {
			type: Boolean,
			default: false
		},
		item: {
			type: Object,
			default () {
				return null
			}
		},
		wishlist: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		isHover: {
			type: Boolean,
			default: true
		},
		isLink: {
			type: Boolean,
			default: true
		},
		styles: {
			type: Array,
			default () {
				return []
			}
		},
		isActionAllowed: {
			type: Boolean,
			default: false
		},
		isRecipeAvailable: {
			type: Boolean,
			default: true
		},
		isRecipeInBox: {
			type: Boolean,
			default: false
		},
		isBoxWithLink: {
			type: Boolean,
			default: false
		},
		updating: {
			type: Boolean,
			default: false
		},
		isOnWishlist: {
			type: Boolean,
			default: false
		},
		quantity: {
			type: Number,
			default: 0
		},
		availability: {
			type: Number,
			default: 999
		},
		path: {
			type: String,
			default: 'recipe'
		},
		homeSlider: {
			type: Boolean,
			default: false
		}
	},

	components: {
		TagsLineOrange,
		InfoTooltip,
		SectionToggle,
		WishlistButton,
		TagPrice
	},

	computed: {
		user () {
			return this.$root.$data.user
		},

		order () {
			return this.user ? this.user.order : null
		},

		people () {
			if (!this.order || !this.order.id) return this.$root.user && this.$root.user.subscription ? this.$root.user.subscription.plan.people : 2
			return this.order.plan.people
		},

		allergens () {
			if (!this.raw) return []
			return this.raw.allergens.map(r => this.allergenName(r)).join(', ')
		},

		tagsMarketing () {
			if (!this.item) return
			return this.item.tags.filter(tag => tag.type === 'marketing')
		},

		isElectrolux () {
			return this.item.tags.find(r => r.name.toLowerCase().includes('electrolux'))
		},

		tagPremium () {
			return this.configStore.config && this.configStore.config['quomi.tags.premium_tag']
				? this.configStore.config['quomi.tags.premium_tag'].toLocaleLowerCase()
				: this.configStore.default.premium_tag.toLocaleLowerCase()
		},
	},

	methods: {
		loadInfo() {

			if (!this.item || this.ingredients) {
				return;
			}

			let api = new RecipeApi;

			this.loading = true;

			api.recipe(this.item.id).then(i => {
				this.raw = i.body.data.resource
				this.loading = false;
			})
		},
		showLabelDoubleIngredients (item) {
			return item.isMixedBox && this.people === 4
		},

		nutritionTags (item) {
			return item && item.product &&item.product.nutrition_tags
				? item.tags.filter(tag => tag.type === 'nutrition').concat(item.product.nutrition_tags)
				: item.tags.filter(tag => tag.type === 'nutrition')
		},
		allergenName (allergen) {
			if (!allergen) return
			return this.$t('components.recipe.allergens.' + allergen.name.toLowerCase().replace(/\s+/g, '_'))
		},

		isRecipePremium (recipe) {
			return !!recipe.tags.find(tag => tag.name.toLowerCase() === this.tagPremium)
		},
		toRecipe(id) {
			this.$router.push({name: 'recipe', params: {id: id}})
		},

		resetCount() {
			window.dispatchEvent(new CustomEvent('reset-count', { 
        bubbles: true
      }));
		}
	},

	mounted () {
		configStore.loadConfig()
	}
}

</script>

<style scoped>
	.unavailable {
		opacity: 0.6;
	}

	.wishlist {
		position: absolute;
		bottom: 0;
		right: 0;
		margin: 10px;
		z-index: 3;
	}

	.recipe-box {
		display: flex;
		flex-direction: column;
		position: relative;
		height: auto;
		flex-grow: 1;
		justify-content: space-between;
	}

	.recipe-name {
		font-weight: bold;
		flex-basis: 100%;
		min-height: 54px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

	}


	.recipe-name .title { 		
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		height: 50px;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.recipe-name .title:hover { 		
		cursor: pointer;
	}

	.homeslider-title:hover { 		
		cursor: unset !important;
	}

	.recipe-name .label {
		font-weight: normal;
		min-height: 22px;

	}

	.recipe-image {
		position: relative;
	}

	.logo {
		height: 20px;
	}

	.recipe-info {
		padding: 15px;
		font-size: 18px;
		display: flex;
		flex-direction: column;
		height: 100%;
		flex-basis: 100%;
		justify-content: space-between;
		position: relative;
	}
	.container-recipe-tags {
    position: absolute;
    margin-left: -5px;
    margin-top: -35px;
    min-height: 35px;

    padding: 5px 15px;
    z-index: 1;
    bottom: 0;
    margin-bottom: -15px;
	}


	.recipe-image >>> .tags-row {
	}

	/*.premium >>> .recipe-action .btn {
		border: 1.5px solid #E5C100;
		background: #E5C100;	
	}*/

	/*.premium >>> .recipe-action .btn.not-in-box {
		color: #E5C100;
	}*/

	.recipe-bottom {
		margin-top: auto;
	}

	.recipe-tag-nutrition {
		display: inline-block;
		color: #575A5C;
		text-transform: lowercase;
		padding-right: 5px;
	}

	.recipe-tag-nutrition img {
		height: 15px;
	}

	.disabled .recipe-bottom {
		opacity: 0.6;
	}

	.recipe-info .recipe-tag-nutrition:before {
		content: '| ';
	}

	.recipe-info .recipe-tag-nutrition + .recipe-tag-nutrition:before {
		content: ' ';
	}

	.hover:hover:after {
		content: 'Scopri cosa ti spediamo';
		color: white;
		position: absolute;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(0, 0, 0, 0.5);
		width: 100%;
		height: 100%;
		border-radius: 4px;
		font-size: 14px;
	}

	.hover:hover {
		cursor: pointer;
	}

	/* .recipe-image >>> .image img{
		border-radius: 4px;
	} */

	.recipe-action .btn.not-in-box  {
		border: 1.5px solid var(--quomi-primary);
		background: var(--quomi-primary);
		color: white;
		padding: 10px;
		width: 100%;
		margin-bottom: 0;
		min-height: 47px;
	}
	.extra-action .btn.full {
		width: 100%;
	} 

	.extra-action .btn {
		margin-bottom: 0px;
	}

	.recipe-action .btn.not-in-box {
		background: white;
		color: var(--quomi-primary);
	}

	.disabled-label {
      color: var(--quomi-orange);
      text-transform: uppercase;
      font-weight: bold;
	    border: 1.5px solid var(--quomi-primary)00;
	    font-size: 15px;
	    margin-top: 10px;
	    display: flex;
			align-items: center;
	    min-height: 47px;
	}

	.section-ingredients {
		justify-content: flex-start;
		margin: 10px 0px;
	}

	.section-ingredients >>> .slider-arrow {
		width: 30px;
		height: 30px;
		box-shadow: none;
		background-color: transparent;
	}

	.ingredient {
		text-align: center;
		line-height: 1.1;
		font-size: 12px;
	}

	.ingredient-badge {
		border-radius: 50%;
		overflow: hidden;
		width: 50px;
		height: 50px;
		margin: 0 auto;
	}

	.ingredient-badge img {
		max-width: inherit;
 		height: 100%;
	}

	.tooltip-i {
		position: absolute;
		right: 0;
		top: 0;
		z-index: 2;
		padding: 10px;
	}

	.section-toggle {
		margin-top: 10px;
	}
	.extra-action {
		display: flex;
		flex-wrap: nowrap;
		font-weight: bold;
		align-items: center;
		justify-content: center;
		min-height: 47px;
	}

	.extra-action .flex-right {
		display: flex;
	}

	.extra-action button {
		padding: 5px 20px;
		background-color: var(--quomi-primary);
		color: white;
		border: 1.5px solid var(--quomi-primary);
	}

	.extra-action .btn:not(.full) {
		font-size: 18px;
		padding: 0 15px;
	}

	.extra-action button.full {
		background-color: var(--quomi-primary);
		color: white;
	}

	.extra-action .quantity-extra {
		font-size: 15px;
    white-space: nowrap;
		padding: 5px 7px;
		z-index: 1;
	}

	@media (max-width: 320px) {
		.extra-action button {
			padding: 5px 13px;
		}

		.hover:hover:after {
			font-size: 10px;
		}

	}

	@media (max-width: 640px) {
		.extra-action div:first-child {
			max-width: unset;
		}

		.extra-action .quantity-extra {
			font-size: 11px;
		}

		.extra-action button {
			border: none;
		}

		.container-recipe-tags {
			display: contents;
		}
		
		.recipe-name .title { 		
		height: 70px;
		margin-bottom: 10px;
	}

		.recipe-info {
			font-size: var(--recipes-info-font-mobile);
			padding: 10px;
			max-height: 100%;
		}

		.recipe-action .btn.not-in-box  {
			min-height: 30px;
			width: 80%;
			margin: 0;
		}

		.ingredient {
			font-size: 11px;
		}

		.section-ingredients {
			font-size: 11px;
			margin: 0;
		}

		.section-toggle {
			margin: 0;
		}

		.disabled-label {
			font-size: var(--recipes-info-font-mobile);
			margin: 0;
		}
	}

	@media only screen and (max-width: 1024px) {
		.extra-action .btn.full {
			width: unset;
		}

		.recipe-action .btn.not-in-box {
			background: var(--quomi-primary);
			color: white;
		}

		.extra-action .quantity-extra {
			text-align: center;
    	white-space: unset;
		}

		.container-recipe-tags {
			display: contents;
			white-space: nowrap;
		}

		.container-recipe-tags .tags-row:nth-child(2) {
			position: absolute;
			right: 0;
			top: 1rem;
			width: max-content;
		}

		.tags-row {
			display: flex;
			flex-wrap: wrap;
			padding-left: 1px;
		}
	}
</style>
